import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { spinnerOff, spinnerOn } from '../../components/Spinner';
import {
  deleteIPSDataTracker,
  deleteProjectAsset,
  post,
  get,
  updateDataTrackerProject,
} from '../../api';

import IpsDTProjectGrid from '../../components/ProjectsGrid/IpsDTProjectGrid';
import Button from 'components/Button';
import IpsDTProjectList from 'components/ProjectsList/IpsDTProjectList';
import IPSDTViewType from 'components/ViewType/IPSDTViewType';
import ConfirmDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/ConfirmDialogBox';
import {
  directToProject,
  handleStartDataTracker,
  startProjectPendingProject,
} from '../../utils/Dashboard';
import DeleteConfirmationDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DeleteConfirmationDialog';
import EditProjectDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/EditProjectDialog';
import DuplicateBPIDDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/DuplicateBPIDDialog';
import MatchProjectsDialog from 'containers/startproj/DataTrackTabs/CommonComponent/DialogBox/MatchProjectsDialog';
import SpinnerNew from "../../components/Spinner/SpinnerNew";

export default withRouter(function DataTrackerAll(props) {
  const {
    context,
    history,
    cardview,
    onViewTypeChange,
    projectList,
    ipsStations,
  } = props;
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reactivateCurrentProject, setReactivateCurrentProject] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reActiveOrDelete, setReactiveOrDelete] = useState('');
  const [deleteCurrentProject, setDeleteCurrentProject] = useState({});
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});
  const [duplicateProjects, setDuplicateProjects] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  
  const [openDuplicateModal, setOpenDuplicateModal] = useState(false);
  const [confirmationDetails, setConfirmationDetails] = useState({});
  const [isBPIDClear, setIsBPIDClear] = useState(false);
  async function getProjects() {
    // if (projects && projects.length < 1) {
    //spinnerOn();
    setIsLoading(true);

    const result = await post(`/ipscards`, '', {});

    setProjects(result.data);
    //spinnerOff();
    setIsLoading(false);
    // }
  }

  useEffect(() => {
    getProjects();
  }, []);
  

  function handleDeleteBtnClick(project) {
    setConfirmDialogDetails({
      title: `Do you want to Delete ${project.stationName}?`,
      handleCancel: handleCancel,
      submitFunctionArgs: project,
      handleSubmit: deleteDataTracker,
      confirmButtonName: 'Yes,Delete',
    });
    setIsModalOpen(true);
  }
  async function deleteDataTracker(project) {
    await deleteIPSDataTracker(project);
    getProjects();
    setIsModalOpen(false);
  }

  async function reactivateProject(project) {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
    };
    await updateDataTrackerProject(projectInfo);
    setIsModalOpen(false);

    directToProject(project, history, 'datatracker_progress', context);
  }

  const handleReactivateProject = (project) => {
    setConfirmDialogDetails({
      title: `Do you want to Re-Activate ${project.stationName}?`,
      handleCancel: handleCancel,
      submitFunctionArgs: project,
      handleSubmit: reactivateProject,
      confirmButtonName: 'Yes,Re-Activate',
    });
    // setReactivateCurrentProject(project);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleMatchedDuplicateCancel = () => {
    setOpenModal(false);
  };
  const handleDeleteCancel = () => {
    setOpenDeleteModal(false);
    setOpenModal(true);
  };

  const handleDelete = () => {
    setConfirmationDetails({
      title: 'Are you sure you want to delete the following project?',
      handleCancel: handleDeleteCancel,
      handleClickOK: deleteDataTracker,
    });

    if (selectedProject) {
      setOpenDeleteModal(true);
      setOpenModal(false);
    }
  };
  const onSelectProject = (project) => {
    setSelectedProject(project);
  };

  async function deleteDataTracker(project) {
    const response = await deleteIPSDataTracker(project);
    if ((response.status = 'SUCCESS')) {
      goToProject(selectedProject);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    }
  }
  const handleEditClick = () => {
    if (selectedProject) {
      setOpenEditModal(true);
      setOpenModal(false);
    }
  };

  const handleEditSave = async (data) => {
    setIsBPIDClear(false);
    const payload = {
      newBPID: data.bpid,
      newStationName: data.stationName,
      newWO: data.workOrder,
      bpid: selectedProject.bpid,
      workOrder: selectedProject.workOrder,
      stationName: selectedProject.stationName,
    };

    const result = await post(`ipsprojects/clone`, '', payload);
    if (result.status === 'SUCCESS') {
      goToProject(selectedProject);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    } else if (
      result.status === 'WARNING' &&
      result.statusMsg === 'DUPLICATE_FOUND'
    ) {
      setOpenDuplicateModal(true);
      setOpenEditModal(false);
      setOpenModal(false);
    }
  };
  const handleDuplicateCancel = () => {
    setOpenDuplicateModal(false);
  };

  const handleClickOK = () => {
    setOpenEditModal(true);
    setIsBPIDClear(true);
    setOpenDuplicateModal(false);
  };

  const handleAccept = () => {
    setConfirmationDetails({
      title: 'Are you sure you want to accept the following project?',
      handleCancel: handleDeleteCancel,
      handleClickOK: acceptDataTracker,
    });
    if (selectedProject) {
      setOpenDeleteModal(true);
      setOpenModal(false);
      setOpenDuplicateModal(false);
      setOpenEditModal(false);
    }
  };
  const acceptDataTracker = async (project) => {
    const result = await post(`ipsprojects/accept`, '', project);
    if (result.status === 'SUCCESS') {
      goToProject(selectedProject);
      getProjects();
      setOpenEditModal(false);
      setOpenDeleteModal(false);
    }
  };
  const redirectToProject = () => {
    
directToProject(projects,history,'datatracker_progress',context)

  };
  const handleEditCancel = () => {
    setOpenEditModal(false);
    setOpenModal(true);
    setIsBPIDClear(false);
  };

  async function goToResolveDuplicateProject(project) {
    const response = await get(
      `ipsprojects/duplicates/${project.tclProjectId}`
    );

    setSelectedProject(null);
    if (response.data.length > 0) {
      const projects = response.data.filter(
        (project) =>
          project.duplicate || project.tclSyncFlag === 'N' || project.manual
      );
      setDuplicateProjects(projects ? projects : []);

      if (projects.length > 0) {
        setOpenModal(true);
      } else {
        setOpenModal(false);
      }

      
    }
  }
  function goToProject(project) {
    let redirectInfo = { history, context };

    switch (project.trackerStatus) {
      case 'DT_P':
        startProjectPendingProject(
          project,
          ipsStations,
          handleStartDataTracker,
          redirectInfo
        );
        break;
      case 'DT_A':
        directToProject(project, history, 'datatracker_progress', context);
        break;
      case 'DT_N':
        handleReactivateProject(project);
        break;
      case 'DT_C':
        directToProject(project, history, 'datatracker_complete', context);
        break;
      case 'DT_D':
        goToResolveDuplicateProject(project);
        break;
      case 'DT_H':
        directToProject(project, history, 'datatracker_hold', context)
        break;

      default:
    }
  }

  return (
    <Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flewGrow: 1,
          justifyContent: 'center',
          paddingRight: '16px',
          paddingBottom: '16px',
        }}
      >
        {/* <Button id="add-new-dt-btn" onClickHandler={handleButtonClick} >Add New Data Tracker</Button> */}
        <div style={{ flexGrow: 1 }} />
        <SpinnerNew display={isLoading}/>
        <IPSDTViewType
          onViewTypeChange={onViewTypeChange}
          tabView={'DT_ALL'}
          
          dtstatus={'DT_ALL'}
        />
      </div>
      {cardview === 'cardview' ? (
        <IpsDTProjectGrid
          projects={projectList(projects)}
          history={history}
          context={context}
          onButtonClick={goToProject}
          isLoading={isLoading}
          handleDeleteBtnClick={handleDeleteBtnClick}
          {...props}
        />
      ) : (
        <IpsDTProjectList
          projects={projectList(projects)}
          onButtonClick={goToProject}
          {...props}
        />
      )}

      <ConfirmDialog
        show={isModalOpen}
        title={confirmDialogDetails.title}
        handleCancel={confirmDialogDetails.handleCancel}
        submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
        handleSubmit={confirmDialogDetails.handleSubmit}
        confirmButtonName={confirmDialogDetails.confirmButtonName}
        cancelButtonName={'No,Cancel'}
      />
      <MatchProjectsDialog
        show={openModal}
        duplicateProjects={duplicateProjects}
        handleCancel={handleMatchedDuplicateCancel}
        handleDelete={handleDelete}
        onSelectProject={onSelectProject}
        onEditClick={handleEditClick}
        onAccept={handleAccept}
        project={selectedProject}
      />
      {selectedProject && (
        <>
          <DeleteConfirmationDialog
            title={confirmationDetails.title}
            show={openDeleteModal}
            project={selectedProject}
            handleCancel={confirmationDetails.handleCancel}
            handleClickOK={confirmationDetails.handleClickOK}
          />

          <EditProjectDialog
            show={openEditModal}
            project={selectedProject}
            stations={ipsStations}
            isBPIDClear={isBPIDClear}
            handleCancel={handleEditCancel}
            onSubmit={handleEditSave}
          />
        </>
      )}
      <DuplicateBPIDDialog
        show={openDuplicateModal}
        handleCancel={handleDuplicateCancel}
        onClickOk={handleClickOK}
        goToProject={redirectToProject}
      />
    </Fragment>
  );
});